import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';

import { useInfiniteQuery } from '@tanstack/react-query';
import { getRoutesQueryKey } from '.';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';

interface UseRetrieveRoutesProps {
  limit?: number;
}

type UseRetrieveRoutesResponseProps = ServiceResponse<() => void, Route[]> & {
  hasMoreRoutes: boolean;
  refetch: () => void;
};

export const useRetrieveRoutes = ({ limit = 25 }: UseRetrieveRoutesProps): UseRetrieveRoutesResponseProps => {
  const { data, hasNextPage, isSuccess, isRefetching, isLoading, isError, fetchNextPage, refetch } = useInfiniteQuery({
    refetchOnWindowFocus: false,
    queryKey: getRoutesQueryKey(),
    queryFn: ({ pageParam = 0 }) =>
      routeService.searchRoutes({
        offset: pageParam,
        limit,
        sort_by: `plan_execution_date`,
        sort_direction: `desc`,
      }),
    getNextPageParam: (lastPage) => {
      if (lastPage.page === lastPage.pages) return undefined;
      return (lastPage.offset ?? 0) + (lastPage.limit ?? limit);
    },
  });

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading || isRefetching,
    data: data?.pages.map((page) => page.docs).flat() ?? [],
    hasMoreRoutes: hasNextPage ?? false,
    run: fetchNextPage,
    refetch: refetch,
  };
};
